<div class="controlarea bordergreen">
    <mat-card class="controlcard borderred" appearance="raised">
        
        <mat-card-content class="controlcard" id="content">
            <div class="controlcard" id="inputs">
                <div class="queryfrequencyformfield" #tooltip="matTooltip" matTooltip="{{ 'QUERY.TOOLTIP.FREQUENCY' | translate}}" matTooltipPosition="below">
                    <!--<a>{{ "QUERY.FREQUENCY" | translate }} </a>-->
                    <a [innerHTML]="'QUERY.FREQUENCY' | translate"> </a>
                    <a>{{this.frequency}} ms</a>   
                </div>

                <div class="controlbutton" id="startstopgroup">
                    <button
                        class="controlbutton"
                        id="startquery"
                        mat-raised-button
                        color="primary"
                        #tooltip="matTooltip"
                        matTooltip="{{ 'QUERY.TOOLTIP.START' | translate}}"
                        matTooltipPosition="below"
                        (click)="startDataQuery()"
                        [disabled]="started"
                    >
                        {{ "QUERY.BTN_START" | translate}}
                    </button>

                    <button
                        class="controlbutton"
                        id="stopquery"
                        mat-raised-button
                        color="primary"
                        #tooltip="matTooltip"
                        matTooltip="{{ 'QUERY.TOOLTIP.STOP' | translate}}"
                        matTooltipPosition="below"
                        (click)="stopDataQuery()"
                    >
                        {{ "QUERY.BTN_STOP" | translate}}
                    </button>
                    <button
                        class="controlbutton"
                        id="deleteDataPoints"
                        mat-stroked-button
                        color="warn"
                        #tooltip="matTooltip"
                        matTooltip="{{ 'QUERY.TOOLTIP.DELETE' | translate}}"
                        matTooltipPosition="below"
                        (click)="cleanDataPoints()"
                        [disabled]="started"
                    >
                    {{ "QUERY.BTN_DELETE" | translate}}
                    </button>
                </div>
            </div>
            
            <div class="queryliveindicator">
                <p class="chip-title">Query</p>
                <mat-chip
                    [ngClass]="{
                        'red-chip': this.queryLive,
                        'grey-chip': !this.queryLive
                    }"
                >
                    {{ this.queryLive ? "Live" : "Stop" }}</mat-chip
                >
            </div>
        </mat-card-content>
    </mat-card>
</div>
